import type { ModalConfig } from "./types";

export const offeringModalsModalUrlConfig = {
  // Offering Modals
  "offerings-detail": {
    modalId: "offerings-detail",
    entityName: "offerings",
    singularParam: "offeringId",
    pluralParam: "offeringsId",
    displayName: "Offering",
  },
} as const satisfies Record<string, ModalConfig>;
